export const setSessionStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const getSessionStorage = (key) => {
  const value = localStorage.getItem(key);
  if (value) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return null;
    }
  }
  return null;
};

export const hasSessionStorage = (key) => {
  return localStorage.getItem(key) !== null;
};

export const removeSessionStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearSessionStorage = () => {
  localStorage.clear();
};
